export function formatUsdt(value: number): string {
  const n = Number(value || 0)
  if (!Number.isFinite(n)) return '0'
  return n.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
}

export function formatCurrency(value: number, currency: string): string {
  const code = (currency || 'BRL').toUpperCase()
  const n = Number(value || 0)
  if (!Number.isFinite(n)) return code === 'BRL' ? 'R$ 0,00' : `0 ${code}`
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: code }).format(n)
  } catch {
    return code === 'BRL' ? `R$ ${n.toFixed(2)}` : `${n.toFixed(2)} ${code}`
  }
}

